module.exports = __webpack_public_path__ + "static/media/nav-logo.0340abc0.svg";